import { PreviewStoreyList, PreviewStoreyListProps } from "./PreviewStoreyList";

interface Props extends PreviewStoreyListProps {
    [key: string]: unknown;
}

const FastPreviewStoreyList: React.FC<Props> = ({ ...props }) => <PreviewStoreyList tool="FAST" {...props} />;

export default FastPreviewStoreyList;